import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { environment } from "../../environments/environment";
import { EmployeeService } from "../shared/services/employee.service";

@Injectable({
  providedIn: "root",
})
export class RegionGuard implements CanActivate {
  constructor(private router: Router, private employeeService: EmployeeService) {}

  canActivate(): Promise<boolean | UrlTree> {
    return new Promise((resolve) => {
      this.employeeService.getBio().subscribe((employee) => {
        if (environment.costOfSalesCountries.includes(employee.company?.companyId)) {
          resolve(true);
        } else {
          resolve(this.router.parseUrl("/"));
        }
      });
    });
  }
}
